import * as React from "react";
import { Button } from "@/components/ui/button";
import { CreatePeriodFormValues } from "./types/types";
import { Label } from "@/components/ui/label";
import { format } from "date-fns";

interface CreatePeriodFormProps {
  formValues: CreatePeriodFormValues;
  setFormValues: React.Dispatch<React.SetStateAction<CreatePeriodFormValues>>;
  onSubmit: () => void;
  onCancel: () => void;
}

export function CreatePeriodForm({
  formValues,
  setFormValues,
  onSubmit,
  onCancel,
}: CreatePeriodFormProps) {
  const handleDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.value) {
      setFormValues({
        ...formValues,
        period: new Date(e.target.value),
      });
    }
  };

  return (
    <div className="space-y-4">
      <div className="space-y-2">
        <Label htmlFor="period">End Date</Label>
        <input
          type="date"
          id="period"
          value={format(formValues.period, "yyyy-MM-dd")}
          onChange={handleDateChange}
          className="w-full rounded-md border p-2"
        />
      </div>

      <div className="flex justify-end gap-2">
        <Button type="button" variant="outline" onClick={onCancel}>
          Cancel
        </Button>
        <Button type="button" onClick={onSubmit}>
          Create Period
        </Button>
      </div>
    </div>
  );
}
